/**
 *
 * NOTE: If using this with `next` version 12.2.0 or lower, uncomment the
 * penultimate line in `CustomErrorComponent`.
 *
 * This page is loaded by Nextjs:
 *  - on the server, when data-fetching methods throw or reject
 *  - on the client, when `getInitialProps` throws or rejects
 *  - on the client, when a React lifecycle method throws or rejects, and it's
 *    caught by the built-in Nextjs error boundary
 *
 * See:
 *  - https://nextjs.org/docs/basic-features/data-fetching/overview
 *  - https://nextjs.org/docs/api-reference/data-fetching/get-initial-props
 *  - https://reactjs.org/docs/error-boundaries.html
 */

import NextErrorComponent from "next/error";

const CustomErrorComponent = (props) => (
  <NextErrorComponent statusCode={props.statusCode} />
);

// This will contain the status code of the response
CustomErrorComponent.getInitialProps = async (contextData) =>
  NextErrorComponent.getInitialProps(contextData);

export default CustomErrorComponent;
